import PropTypes from 'prop-types';
import React from 'react';
import {Unveil} from '@homeaway/react-unveil';

import './Logo.less';

const Logo = (props) => {
    const {data} = props;

    if (!data || !data.image) {
        return null;
    }

    return (
        <Unveil className="SiteFooter__logo hidden-xs" useWindowAsScrollParent>
            <a href={data.link} target={'_blank'}>
                <img src={data.image} alt={data.text} />
            </a>
        </Unveil>
    );
};

Logo.propTypes = {
    data: PropTypes.shape({
        image: PropTypes.string,
        link: PropTypes.string,
        text: PropTypes.string
    })
};

export default Logo;
